export default __webpack_public_path__ + "static/media/deflaut-user-image.9999920b.webp";